import agentConfiguration from './agentConfiguration.json';
import assigneeModal from './assigneeModal.json';
import attributes from './attributes.json';
import auth from './auth.json';
import billing from './billing.json';
import branding from './branding.json';
import common from './common.json';
import contacts from './contacts.json';
import contractors from './contractors.json';
import contracts from './contracts.json';
import creator from './creator.json';
import crmDashboard from './crmDashboard.json';
import dashboard from './dashboard.json';
import employees from './employees.json';
import home from './home.json';
import onboarding from './onboarding.json';
import partnerCustomers from './partnerCustomers.json';
import profile from './profile.json';
import sessionDetails from './sessionDetails.json';
import sessions from './sessions.json';
import settings from './settings.json';
import sidebar from './sidebar.json';
import team from './team.json';
import testEmployee from './testEmployee.json';
import vibeCreator from './vibeCreator.json';
import widgets from './widgets.json';

export default {
	agentConfiguration,
	assigneeModal,
	common,
	home,
	auth,
	crmDashboard,
	employees,
	dashboard,
	sidebar,
	contacts,
	contracts,
	sessions,
	team,
	attributes,
	settings,
	widgets,
	billing,
	branding,
	creator,
	profile,
	partnerCustomers,
	sessionDetails,
	onboarding,
	contractors,
	vibeCreator,
	testEmployee
};
